import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BACKEND_URL } from '../config';
import Layout from '../components/Layout';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Calendar, Clock, IndianRupee, Music } from 'lucide-react';

const Home = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/settings`)
      .then(res => setSettings(res.data))
      .catch(err => console.error("Failed to load settings", err));
  }, []);

  if (!settings) return null; // Or a loader

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative py-20 px-4 text-center overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1769888913192-897f2f097d04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB0ZW1wbGUlMjBhcmNoaXRlY3R1cmUlMjB0ZXh0dXJlJTIwc3RvbmV8ZW58MHx8fHwxNzcwOTUxMTY3fDA&ixlib=rb-4.1.0&q=85')] opacity-10 bg-cover bg-center z-0"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto space-y-6 animate-fade-in">
          <span className="inline-block px-4 py-1 border border-primary/30 rounded-full text-primary text-sm font-semibold tracking-widest uppercase mb-4 bg-white/50">
            250th Jayanthi Year Celebration
          </span>
          <h1 className="text-5xl md:text-7xl font-bold text-primary leading-tight">
            {settings.event_title}
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground mt-4 max-w-2xl mx-auto leading-relaxed">
            Learn 6 gems of the great composer from {settings.guru_name} in an exclusive 3-day workshop.
          </p>
          
          <div className="pt-8">
            <Link to="/register">
              <button className="bg-primary text-white px-8 py-4 text-lg font-serif rounded shadow-lg hover:bg-primary/90 transition-all transform hover:-translate-y-1">
                Register Now
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Details Grid */}
      <section className="py-16 bg-white/40">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded shadow-sm border border-primary/10 hover:border-primary/30 transition-colors">
              <Calendar className="w-8 h-8 text-secondary mb-4" />
              <h3 className="text-xl font-bold mb-2">Dates</h3>
              <p>{settings.dates}</p>
            </div>
            <div className="bg-white p-6 rounded shadow-sm border border-primary/10 hover:border-primary/30 transition-colors">
              <Clock className="w-8 h-8 text-secondary mb-4" />
              <h3 className="text-xl font-bold mb-2">Time</h3>
              <p>{settings.time}</p>
            </div>
            <div className="bg-white p-6 rounded shadow-sm border border-primary/10 hover:border-primary/30 transition-colors">
              <IndianRupee className="w-8 h-8 text-secondary mb-4" />
              <h3 className="text-xl font-bold mb-2">Fee</h3>
              <p>₹{settings.fee} <br />(All 3 Days)</p>
            </div>
            <div className="bg-white p-6 rounded shadow-sm border border-primary/10 hover:border-primary/30 transition-colors">
              <Music className="w-8 h-8 text-secondary mb-4" />
              <h3 className="text-xl font-bold mb-2">Format</h3>
              <p>Online Session <br />via Zoom</p>
            </div>
          </div>
        </div>
      </section>

      {/* Guru Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-5xl flex flex-col md:flex-row items-center gap-12">
          <div className="w-full md:w-1/3">
             <div className="relative">
                <div className="absolute inset-0 bg-secondary rounded-lg transform rotate-6 translate-x-2 translate-y-2"></div>
                <img 
                  src="https://images.unsplash.com/photo-1763475945300-02cf0355b078?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHx2ZWVuYSUyMGluc3RydW1lbnR8ZW58MHx8fHwxNzcwOTUxMTgzfDA&ixlib=rb-4.1.0&q=85" 
                  alt="Saraswati Veena" 
                  className="relative rounded-lg shadow-xl w-full h-auto object-cover aspect-[3/4]"
                />
             </div>
          </div>
          <div className="w-full md:w-2/3 space-y-6">
            <h2 className="text-4xl font-bold text-primary">About the Guru</h2>
            <h3 className="text-2xl font-serif text-secondary-foreground">{settings.guru_name}</h3>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Former HOD (Dept of Music), Potti SreeRamulu Telugu University, Hyderabad. A distinguished scholar and performer, Dr. Uma Devi brings decades of teaching experience and deep insight into the intricacies of Muthuswamy Deekshitar's compositions.
            </p>
            <ul className="space-y-2 list-disc list-inside text-muted-foreground">
              <li>Learn authentic Patanthara</li>
              <li>Understand the Sahitya meanings</li>
              <li>Explore Raga Lakshanas</li>
            </ul>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
